export const VALIDATION_RULES = (t: any) => {
  return {
    required: {
      value: true,
      message: t("required_message"),
    },
    pattern: {
      value: /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g,
      message: t("invalid_color"),
    },
  };
};
